import { render, staticRenderFns } from "./AvgSidebar.vue?vue&type=template&id=c3fca54c&scoped=true&"
import script from "./AvgSidebar.vue?vue&type=script&lang=ts&"
export * from "./AvgSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./AvgSidebar.vue?vue&type=style&index=0&id=c3fca54c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fca54c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3fca54c')) {
      api.createRecord('c3fca54c', component.options)
    } else {
      api.reload('c3fca54c', component.options)
    }
    module.hot.accept("./AvgSidebar.vue?vue&type=template&id=c3fca54c&scoped=true&", function () {
      api.rerender('c3fca54c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AvgSidebar.vue"
export default component.exports